import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ExtractedSingleShowcaseResource,
  NYTShowcasesList,
  SHOWCASES_PARAMS,
  ShowcasesEntity,
  ShowcasesTypes
} from 'search/full-card/models/showcases';
import { Breakpoints } from '../../../../../../models/viewport';
import { ViewportService } from '../../../../../../services/viewport.service';

@Component({
  selector: 'app-nyt-showcase-view',
  templateUrl: './nyt-showcase-view.component.html',
  styleUrls: ['./nyt-showcase-view.component.scss'],
})
export class NytShowcaseViewComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() public resources: ExtractedSingleShowcaseResource[];
  @Input() public totalCount: number;
  @Input() public showcaseId: string;
  @Input() public identifier: string;
  @Input() public showcaseType: string;
  @Input() public name: string;
  @Input() public entity: ShowcasesEntity;

  public isNYTshowcaseSeeAllButtonVisible: boolean;
  public isNYTshowcaseSeeAllButtonVisibleMobile: boolean;
  public isSeeAllButtonVisible: boolean;
  public visibleItemLength: number;
  public resourcePerPage: number;
  public showcasesTypes = ShowcasesTypes;

  private readonly subscriptions = new Subscription();
  private isWiderThanXs: boolean;

  constructor(
    private readonly translateService: TranslateService,
    private readonly viewportService: ViewportService,
  ) {
  }

  ngOnChanges(): void {
    if (this.entity.entityType === 'Instance' || this.entity.entityType === 'FormatGroup') {
      this.isSeeAllButtonVisible = this.totalCount > SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE;
      this.resourcePerPage = SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE;
      this.isNYTshowcaseSeeAllButtonVisible = this.totalCount > SHOWCASES_PARAMS.RESOURCES_PER_NYTSHOWCASE_RESOURCE_PAGE;
      this.isNYTshowcaseSeeAllButtonVisibleMobile = this.totalCount > SHOWCASES_PARAMS.RESOURCES_PER_NYTSHOWCASE_RESOURCE_PAGE_MOBILE;
    } else {
      this.isSeeAllButtonVisible = this.totalCount > SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_PAGE;
      this.resourcePerPage = SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_PAGE;
    }
  }

  ngOnInit(): void {
    this.name = this.translateNYTShowcasesList(this.name);

    this.subscriptions.add(
      this.viewportService.isWiderThan(Breakpoints.RESOLUTION_MAX_XS)
      .subscribe((isWiderThanXs) => {
        this.isWiderThanXs = isWiderThanXs;
        this.visibleItemLength = this.setResourcesLength();
      }),
    );
  }

  ngAfterViewInit(): void {
    this.visibleItemLength = this.setResourcesLength();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public setResourcesLength(): number {
    return this.isWiderThanXs ?
      SHOWCASES_PARAMS.RESOURCES_PER_NYTSHOWCASE_RESOURCE_PAGE :
      SHOWCASES_PARAMS.RESOURCES_PER_NYTSHOWCASE_RESOURCE_PAGE_MOBILE;
  }

  public translateNYTShowcasesList(name: string): string {
    switch (name) {
      case NYTShowcasesList.Fiction: {
        return this.translateService.instant('NYTFiction');
      }
      case NYTShowcasesList.Nonfiction: {
        return this.translateService.instant('NYTNonfiction');
      }
      case NYTShowcasesList.YoungAdult: {
        return this.translateService.instant('NYTYoungAdult');
      }
      case NYTShowcasesList.MiddleGrade: {
        return this.translateService.instant('NYTMiddleGrade');
      }
      case NYTShowcasesList.PictureBooks: {
        return this.translateService.instant('NYTPictureBooks');
      }
      default: {
        return name;
      }
    }
  }

}
